import styled from 'styled-components';
import get from 'lodash/get';
import { observer } from 'mobx-react';

import { identity, medal, room } from 'widgets/lib';
import { user as libUser } from 'lib';
import idenConfig from 'modules/widgets/ui/iden/iden-config';
import {
  TagLove,
  CoinLevel,
  RichLevel,
  StarLevel,
  WeekSpendLevel,
  NobleLevel,
  SuperNobleLevel,
  StarVipLevel,
  NewUserLevel,
  LuckyStar,
} from 'components';

import { PayLevel } from 'components/ui';
import { IconAndroid, IconIos, IconYouqu } from 'widgets/ui/iden/styled';
import {
  // IdenStar,
  IdenPriv,
  IdenGuard,
  IdenAdmin,
  IdenCost,
  IdenLoveGroup,
  IdenMedal,
  IdenNewUser,
  IdenHonorFans,
  IdenNum,
  IdenVip,
  IdenFamily,
  IdenMystic,
  IdenIos,
  IdenAndroid,
} from './index';

const renderItems = (items, props) => {
  return items.map((item, index) => {
    if (typeof item === 'string') {
      item = {
        key: item,
      };
    }

    const Com = renders[item.key];
    if (Com) {
      return <Com key={item.key} {...props} params={item.params} />;
    }
    return null;
  });
};
// *****  所有信息流中的标识  **************
const Idens = {};
// 运营
Idens.Operator = (props) => {
  const { user } = props;
  if (user.priv === 1) {
    return <IdenPriv priv={user.priv} />;
  }
  return null;
};
// 本场消费等级 1，2，3
Idens.CostLevel = (props) => {
  const { user } = props;
  if (user.costTopIndex) {
    return <IdenCost topIndex={user.costTopIndex} />;
  }
  return null;
};
// 管理标识
Idens.Admin = (props) => {
  const { user } = props;
  if (user.isAdmin || user.admin) {
    return <IdenAdmin />;
  }
  return null;
};
// 真爱守护
Idens.Guard = (props) => {
  const { user } = props;
  if (user.group_info) {
    const {
      guard_type = 0,
      group_name = '',
      group_level = 0,
    } = user.group_info;
    if (group_level) {
      return (
        <TagLove guard={guard_type} name={group_name} level={group_level} />
      );
    }
    return null;
  }
  return null;
};
// 等级标识（【数字等级、富豪等级、新人标识】/【主播等级】）
Idens.Level = (props) => {
  const { user, params } = props;
  if (params) {
    if (user.priv === 2 && isRoomOwner(user._id)) {
      return renderItems(params.star, props);
    }
    return renderItems(params.user, props);
  }
  return null;
};

// 登录平台标识（ios/安卓）
Idens.LoginPlatform = (props) => {
  const { user, params } = props;
  const { last_login_platform } = user || {};
  // 仅主播展示
  if (libUser.isStar() && last_login_platform) {
    const Icon = {
      android: IdenAndroid,
      ios: IdenIos,
    }[last_login_platform.toLowerCase()];

    return Icon ? <Icon /> : null;
  }

  return null;
};
// 登录平台标识（ios/安卓）
Idens.LoginPlatformIcon = (props) => {
  const { user, params } = props;
  const { last_login_platform } = user || {};
  // 仅主播展示
  if (libUser.isStar() && last_login_platform) {
    const Icon = {
      android: IconAndroid,
      ios: IconIos,
    }[last_login_platform.toLowerCase()];

    return Icon ? <Icon /> : null;
  }

  return null;
};
// 主播标识
Idens.Star = (props) => {
  const { user } = props;
  if (user.priv === 2) {
    return <IdenPriv priv={2} isRoomOwner={isRoomOwner(user._id)} />;
  }
  return null;
};
// 进场称号
Idens.EnterName = (props) => {
  const { user } = props;
  if (user.enter_info && user.enter_info !== 'null') {
    return (
      <span className={`enter-name enter-name-${user.enter_info_bg || 1}`}>
        <span className="enter-name-inner">{user.enter_info}</span>
      </span>
    );
  }
  return null;
};
// 公会标识
Idens.Guild = (props) => {
  const { user } = props;
  if (user.priv === 5) {
    const guild_priv = get(user, 'guild.guild_priv', user.guild_priv);
    return <IdenPriv {...user} guild_priv={guild_priv} />;
  }
  return null;
};
// 巡警
Idens.Gm = (props) => {
  const { user } = props;
  if (user.priv === 6) {
    return <IdenPriv priv={user.priv} />;
  }
  return null;
};
// 靓号
Idens.MemeNum = (props) => {
  const { user } = props;
  return (
    <IdenNum
      userId={user._id || user.uid}
      mmNo={user.mm_no}
      priceType={user.mm_no_price_type}
    />
  );
};
// VIP
Idens.Vip = (props) => {
  const { user } = props;
  return <IdenVip vip={user.vip} />;
};
// 家族标识
Idens.Family = (props) => {
  const { user } = props;
  const badgeName = user.badge_name || get(user, 'family.badge_name');
  const isFirst = false;
  if (badgeName) {
    return <IdenFamily badgeName={badgeName} isFirst={isFirst} />;
  }
  return null;
};
// 徽章，仅称号类徽章
Idens.Medal = (props) => {
  const { user, params } = props;
  // medal_type 1礼物，2活动，3系统荣，4称号
  // let medalList = user.medal_list || [];
  // medalList = medalList
  //   .map((item) => {
  //     return medal.getMedal(item);
  //   })
  //   .filter((item) => {
  //     return item && params.medal_type.includes(item.medal_type);
  //   });

  // 新版 装扮里的徽章体系
  const allDecorators = window.MM_DECORATOR || [];
  let decoratorMedals = get(user, 'decorator.medal', []).slice(0, 2);

  if (decoratorMedals.length > 0) {
    decoratorMedals = decoratorMedals
      .map((medalId) => {
        return allDecorators.find((item) => {
          return item._id === `${medalId}`;
        });
      })
      .filter((item) => {
        return !!item && item._id;
      });
  }
  return (
    <>
      {/* {medalList.map((item) => (
        <img
          key={item._id}
          src={item.small_pic}
          alt={item.name}
          className="message-medal"
          title={item.name}
        />
      ))} */}
      {decoratorMedals.map((item) => {
        return (
          <img
            key={item._id}
            src={item.medals}
            alt={item.name}
            className="message-medal"
            title={item.name}
          />
        );
      })}
    </>
  );
};

// 新人标识
Idens.New = (props) => {
  const { user } = props;
  if (user.new_user_level) {
    return <IdenNewUser new_user_level={user.new_user_level} />;
  }
  if (
    user.is_24_hr_new_user ||
    user.is24_hr_new_user ||
    user.is_24hr_new_user
  ) {
    return <IdenNewUser />;
  }
  return null;
};

// 荣耀粉丝
Idens.HonourFans = (props) => {
  const { user } = props;
  const { honor_fans } = user;
  if (honor_fans) {
    return <IdenHonorFans />;
  }
  return null;
};

// 数字等级
Idens.CoinLevel = (props) => {
  const { user } = props;
  const coinSpendTotal = get(user, 'finance.coin_spend_total', user.spend) || 0;
  return (
    <CoinLevel
      weekSpend={user.week_spend}
      coin={coinSpendTotal}
      level={user.coin_level || 0}
    />
  );
};
// 充值等级
Idens.PayLevel = (props) => {
  const { user } = props;
  const level = get(user, 'pay_level_info.level', user.pay_level || 0);
  return <PayLevel level={level} />;
};

// 富豪等级
Idens.RichLevel = (props) => {
  // return null;
  const { user } = props;
  const coinSpendTotal = get(user, 'finance.coin_spend_total', user.spend);

  return <RichLevel coin={coinSpendTotal || 0} />;
};

// 闪耀周星
Idens.WeekSpendLevel = (props) => {
  const { user } = props;
  return <WeekSpendLevel weekSpend={user.week_spend || 0} />;
};

// 主播等级
Idens.StarLevel = (props) => {
  const { user } = props;
  const beanCountTotal =
    get(user, 'finance.benefit_total', user.benefit_total) || 0;
  const uid = user._id || user.uid;
  const show = isRoomOwner(uid) || user.isMicStar;
  // if(user.micList){
  //   show = !!user.micList.find(item => item.id === uid || item.uid === uid)
  // }
  if (user.priv === 2 && show) {
    return <StarLevel bean={beanCountTotal} />;
  }
  return null;
};

// 贵族等级 *********** 已弃用 ***********
Idens.NobleLevel = (props) =>
  // const { user } = props;
  // if (user.noble?.level) {
  //   return <NobleLevel level={user.noble.level} />;
  // }
  {
    return null;
  };

// 超R *********** 已弃用 ***********
Idens.SuperNobleLevel = (props) =>
  // const { user } = props;
  // if (eval(user.noble?.senior)) {
  //   return <SuperNobleLevel></SuperNobleLevel>;
  // }
  {
    return null;
  };
// 神秘人
Idens.Mystic = (props) => {
  const { user } = props;
  if (user.mystic?.open) {
    const { title, title_pic } = user.mystic;
    return <IdenMystic title={title} pic={title_pic} />;
  }
  return null;
};

// 星钻会员 *********** 已弃用 ***********
Idens.StarVipLevel = (props) =>
  // const { user } = props;
  // if (!user.star_vip?.type) {
  //   return null;
  // }
  // if (user.star_vip?.type) {
  //   return <StarVipLevel level={user.star_vip.type}></StarVipLevel>;
  // }
  {
    return null;
  };

// 幸运大咖
Idens.LuckyStar = (props) => {
  const { user } = props;
  if (user.lucky_star) {
    return <LuckyStar />;
  }
  return null;
};

Idens.NewUserLevel = (props) => {
  const { user } = props;
  if (user.new_user_level) {
    return <NewUserLevel level={user.new_user_level} />;
  }
  return null;
};

Idens.AppType = (props) => {
  const { user } = props;
  if (user.app_type === 'youqu' || user.packet_name === 'com.gaopeng.party') {
    return <IconYouqu></IconYouqu>;
  }
  return null;
};

const renders = {
  // 运营
  operator: Idens.Operator,
  // 本场消费TOP3
  cost_level: Idens.CostLevel,
  // 管理，房管
  admin: Idens.Admin,
  // 守护
  guard: Idens.Guard,
  // 等级（自动区分【当前主播】和【用户】）
  level: Idens.Level,
  // 主播标识
  star: Idens.Star,
  // 登录平台 文字
  login_platform: Idens.LoginPlatform,
  // 登录平台 图标
  login_platform_icon: Idens.LoginPlatformIcon,
  // 进场自定义称号
  enter_name: Idens.EnterName,
  // 公会
  guild: Idens.Guild,
  gm: Idens.Gm,
  // 靓号
  mm_no: Idens.MemeNum,
  // vip，已废除
  vip: Idens.Vip,
  // 家族
  family: Idens.Family,
  // 装扮头衔称号
  medal: Idens.Medal,
  // 新人
  new: Idens.New,
  // 1: 普通新用户, 2: 活跃新用户, 3: 潜力新用户
  new_user_level: Idens.NewUserLevel,
  // 荣耀粉丝
  honour_fans: Idens.HonourFans,
  // 数字等级，已废除
  coin_level: Idens.CoinLevel,
  // 充值等级（会员等级）
  pay_level: Idens.PayLevel,
  // 财富等级（消费称号）
  rich_level: Idens.RichLevel,
  // 主播等级
  star_level: Idens.StarLevel,
  // 贵族等级，已废除
  noble_level: Idens.NobleLevel,
  // 超级贵族，已废除
  super_noble: Idens.SuperNobleLevel,
  // 神秘人
  mystic: Idens.Mystic,
  // 星钻等级，已废除
  star_vip_level: Idens.StarVipLevel,
  // 闪耀周星，闪耀财星
  week_spend_level: Idens.WeekSpendLevel,
  // 幸运大咖
  lucky_star: Idens.LuckyStar,
  app_type: Idens.AppType,
};

// 神秘人标识
const mysticIdenConfig = [{ key: 'mystic', desc: '神秘人' }];

const renderMysticIden = (user, cb) => {
  if (user.mystic?.open) {
    return renderItems(mysticIdenConfig, { user });
  }
  return cb();
};

const isRoomOwner = (userId) => {
  const roomId = room.getRoomId();
  return userId === roomId;
};

const IdenCommon = (props) => {
  const { user: userInfo, type = '', config, excludes = [] } = props;
  const user = identity.formatUserData(userInfo);
  let renderConfig = config || idenConfig[type] || idenConfig.msgCommon;
  if (excludes.length) {
    renderConfig = renderConfig.filter((item) => {
      return !excludes.includes(item);
    });
  }

  // console.log(renderConfig, 8888);
  return renderMysticIden(user, () => {
    return renderItems(renderConfig, { user });
  });
};

// 聊天信息流 标识
const MsgChatIden = (props) => {
  const user = identity.formatUserData(props.user);

  return renderMysticIden(user, () => {
    return renderItems(idenConfig.msgChat, { user });
  });
};
// 进场信息流 标识
const MsgEnterIden = (props) => {
  const user = identity.formatUserData(props.user);
  return renderMysticIden(user, () => {
    if (isRoomOwner(user._id)) {
      return renderItems(idenConfig.msgRoomOwner, { user });
    }
    return renderItems(idenConfig.msgEnter, { user });
  });
};

// 送礼信息流 标识
const MsgGiftIden = (props) => {
  const user = identity.formatUserData(props.user);
  return renderMysticIden(user, () => {
    if (isRoomOwner(user._id)) {
      return renderItems(idenConfig.msgRoomOwner, { user });
    }
    return renderItems(idenConfig.msgGift, { user });
  });
};

// 用户列表
const UserListIden = (props) => {
  const user = identity.formatUserData(props.user);
  const { excludes = [] } = props; // excludes  排除显示的图标

  let renderConfig = idenConfig.userList;

  if (excludes.length) {
    renderConfig = idenConfig.userList.filter((item) => {
      return !excludes.includes(item);
    });
  }

  return renderMysticIden(user, () => {
    return renderItems(renderConfig, { user });
  });
};

export {
  Idens,
  MsgChatIden,
  MsgEnterIden,
  MsgGiftIden,
  UserListIden,
  IdenCommon,
  renders,
};
